import React, { FC, ReactNode, useEffect, useState } from 'react';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { ProCol, ProRow } from '../antd';
import classnames from 'classnames';
import { SearchFormItemEnum } from './interface/baseInterface';
import { SearchFormItemProps } from './index';
import { ColProps } from 'antd/lib/col';
import { groupOptionsProps } from '../SuperForm/interface';

export interface SearchFormGroupProps {
  /** form表单 */
  form?: any;
  /** 分组标题 */
  label?: ReactNode;
  /** 必传 */
  required?: boolean;
  /** 分组类名 */
  className?: string;
  /** 分组标题类名 */
  labelClassName?: string;
  /** 分组内容类名 */
  containerClassName?: string;
  /** 每行显示多少个表单 */
  defaultLineNumber?: number;
  /** 每个Item的默认labelCol配置 */
  defaultLabelCol?: ColProps;
  /** 分组转换配置 */
  groupOptions?: groupOptionsProps;
  /** 是否可以收起 */
  shrink?: boolean;
  /** 默认值 收起 false 展开 true */
  defaultShrinkValue?: boolean;
  /** 测试ID */
  testId?: string;
  children?: ReactNode;
}
/** 分组 */
export const SearchFormGroup: FC<SearchFormGroupProps> = props => {
  const {
    form,
    label,
    labelClassName,
    defaultLineNumber,
    defaultLabelCol,
    testId,
    children,
    className,
    required,
    containerClassName,
    shrink,
    defaultShrinkValue = true,
  } = props;
  const [open, setOpen] = useState<boolean>(defaultShrinkValue);
  useEffect(() => {
    setOpen(defaultShrinkValue);
  }, [defaultShrinkValue]);
  const classes = classnames('yb-form-group', labelClassName,);
  const labelClasses = classnames('yb-form-label', { required: !!required });
  const renderChildren = () => {
    let spanNumber: number | undefined = defaultLineNumber
      ? Math.floor(24 / defaultLineNumber)
      : undefined;
    return React.Children.map(children, child => {
      const childElement = child as React.FunctionComponentElement<
        SearchFormItemProps
      >;
      const { displayName } = childElement.type;
      if (displayName && displayName in SearchFormItemEnum) {
        if (displayName === SearchFormItemEnum.SearchFormTabs) {
          const otherParams: any = {
            form,
            span: childElement.props.span || spanNumber,
            labelCol: { ...defaultLabelCol, ...childElement.props.labelCol },
          };
          return React.cloneElement(childElement, otherParams);
        }
        const otherParams: any = {
          form,
          testId,
          span: childElement.props.span || spanNumber,
          labelCol: { ...defaultLabelCol, ...childElement.props.labelCol },
        };
        if (displayName === SearchFormItemEnum.SearchFormGroup || displayName === SearchFormItemEnum.SearchFormFixed) {
          otherParams.defaultLineNumber = childElement.props.defaultLineNumber || defaultLineNumber;
          otherParams.defaultLabelCol = childElement.props.defaultLabelCol || defaultLabelCol;
        }
        return React.cloneElement(childElement, otherParams);
      } else {
        console.error(
          'Warning: SearchForm has a child which is not a Item component',
        );
      }
    });
  };
  return (
    <div className={className} style={{ width: '100%' }}>
      {label && (
        <ProCol span={24}>
          <div className={classes}>
            <span className={labelClasses}>{label}</span>
            {
              shrink && (
                <span
                  className='yb-form-group-shrink'
                  title={open ? '收起' : '展开'}
                  onClick={() => setOpen(prev => !prev)}
                >
                  {open ? <UpOutlined /> : <DownOutlined />}
                </span>
              )
            }
          </div>
        </ProCol>
      )}
      <ProCol span={24} className={containerClassName} style={open ? {} : { display: 'none'}}>
        <ProRow gutter={24}>{renderChildren()}</ProRow>
      </ProCol>
    </div>
  );
};

SearchFormGroup.displayName = SearchFormItemEnum.SearchFormGroup;

SearchFormGroup.defaultProps = {
  shrink: true,
  defaultShrinkValue: true,
};

export default SearchFormGroup;
